import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getTagListing = createAsyncThunk(
  "tagListing/getTagListing",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/tag/get_all_data`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        {}
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const tagListingSlice = createSlice({
  name: "tagListing",
  initialState: {
    loading: false,
    tagListingData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTagListing.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTagListing.fulfilled, (state, action) => {
        state.loading = false;
        state.tagListingData = action.payload;
      })
      .addCase(getTagListing.rejected, (state, action) => {
        state.loading = false;
        state.tagListingData = action.payload;
        state.error = action.payload;
      });
  },
});

export default tagListingSlice.reducer;
